import OperationIcon from "@/assets/icons/services/ai/impact/operation.svg";
import CustomerIcon from "@/assets/icons/services/ai/impact/customer.svg";
import ProcessIcon from "@/assets/icons/services/ai/impact/process.svg";
import ReportingIcon from "@/assets/icons/services/ai/impact/reporting.svg";
import DocumentIcon from "@/assets/icons/services/ai/impact/document.svg";
import DecisionIcon from "@/assets/icons/services/ai/impact/decision.svg";

import fasterIcon from "@/assets/icons/services/ai/success/internal.svg";
import workloadIcon from "@/assets/icons/services/ai/success/workload.svg";
import visibilityIcon from "@/assets/icons/services/ai/success/visibility.svg";
import processIcon from "@/assets/icons/services/ai/success/process.svg";

import automative from "@/assets/icons/odoomanufacturing/automative.svg?react";
import cables from "@/assets/icons/odoomanufacturing/cables.svg?react";
import chemical from "@/assets/icons/odoomanufacturing/chemical.svg?react";
import concrete from "@/assets/icons/odoomanufacturing/concrete.svg?react";
import cosmetics from "@/assets/icons/odoomanufacturing/cosmetics.svg?react";
import industry from "@/assets/icons/odoomanufacturing/industry.svg?react";
import food from "@/assets/icons/odoomanufacturing/food.svg?react";
import footwear from "@/assets/icons/odoomanufacturing/footwear.svg?react";
import textile from "@/assets/icons/odoomanufacturing/textile.svg?react";
import electric from "@/assets/icons/odoomanufacturing/electric.svg?react";
import fashion from "@/assets/icons/odoomanufacturing/fashion.svg?react";
import leather from "@/assets/icons/odoomanufacturing/leather.svg?react";
import equipment from "@/assets/icons/odoomanufacturing/equipment.svg?react";
import gold from "@/assets/icons/odoomanufacturing/gold.svg?react";
import pharmaceuticals from "@/assets/icons/odoomanufacturing/pharmaceutical.svg?react";
import plastic from "@/assets/icons/odoomanufacturing/plastic.svg?react";
import printing from "@/assets/icons/odoomanufacturing/printing.svg?react";
import rubber from "@/assets/icons/odoomanufacturing/rubber.svg?react";
import steel from "@/assets/icons/odoomanufacturing/steel.svg?react";
import wood from "@/assets/icons/odoomanufacturing/wood.svg?react";
import aluminium from "@/assets/icons/odoomanufacturing/aluminium.svg?react";

import businessIcon from "@/assets/icons/services/ai/why-choose/business.svg";
import solutionIcon from "@/assets/icons/services/ai/why-choose/cloud.svg";
import integrationIcon from "@/assets/icons/services/ai/why-choose/integration.svg";
import practicalIcon from "@/assets/icons/services/ai/why-choose/practical.svg";
import supportIcon from "@/assets/icons/services/ai/why-choose/ete-support.svg";
import approchIcon from "@/assets/icons/services/ai/why-choose/approch.svg";

import business from "@/assets/images/services/ai-implementation/why-choose/business.webp";
import solution from "@/assets/images/services/ai-implementation/why-choose/ai-solutions.webp";
import integration from "@/assets/images/services/ai-implementation/why-choose/integration.webp";
import practical from "@/assets/images/services/ai-implementation/why-choose/practical.webp";
import support from "@/assets/images/services/ai-implementation/why-choose/support.webp";
import approch from "@/assets/images/services/ai-implementation/why-choose/approch.webp";

const aiServices = {
  "ai-implementation": {
    slug: "ai-implementation",
    name: "AI Implementation",

    hero: {
      title: "AI Implementation for Measurable Business Impact",
      description:
        "Our AI Implementation approach combines intelligent automation, data-driven decision support, and workflow integration  to create measurable value across business operations.",
    },
    impact: {
      title: "Where AI Creates Immediate High Impact",
      description:
        "AI creates the fastest value when applied to areas that already consume time, create delays, or depend heavily on repetitive effort.",
      buttonText: "Talk With Us",
      cases: [
        {
          title: "Operations",
          image: OperationIcon,
        },
        {
          title: "Customer Support",
          image: CustomerIcon,
        },
        {
          title: "Sales Processes",
          image: ProcessIcon,
        },
        {
          title: "Internal Reporting",
          image: ReportingIcon,
        },
        {
          title: "Document Handling",
          image: DocumentIcon,
        },
        {
          title: "Decision Support",
          image: DecisionIcon,
        },
      ],
    },

    result: {
      title: "What Success Looks Like After 90 Days",
      description:
        "A well-executed AI implementation should begin creating visible operational improvements within the first few months. ",
      resultData: [
        {
          icon: fasterIcon,
          title: "Faster Internal Execution",
        },
        {
          icon: workloadIcon,
          title: "Reduced Repetitive Workload",
        },
        {
          icon: visibilityIcon,
          title: "Improved Visibility",
        },
        {
          icon: processIcon,
          title: "Better Process Consistency",
        },
      ],
    },

    manufacturing: {
      title: "Manufacturing Industries We Serve",
      description:
        "We deliver industry-specific Odoo solutions that streamline complex manufacturing processes and connect every department on a single platform.",
      ManufacturingData: [
        {
          id: "industry1",
          title: "Automative Parts Industry",
          icon: automative,
        },
        {
          id: "industry2",
          title: "Cables and Wires Industry",
          icon: cables,
        },
        {
          id: "industry3",
          title: "Chemicals Industry",
          icon: chemical,
        },
        {
          id: "industry4",
          title: "Concrete Ready-Mix Industry",
          icon: concrete,
        },
        {
          id: "industry5",
          title: "Cosmetic Industry",
          icon: cosmetics,
        },
        {
          id: "industry6",
          title: "FMCG Industry",
          icon: industry,
        },
        {
          id: "industry7",
          title: "Food & Beverages Industry",
          icon: food,
        },
        {
          id: "industry8",
          title: "Footwear Industry",
          icon: footwear,
        },
        {
          id: "industry9",
          title: "Textile Industry",
          icon: textile,
        },
        {
          id: "industry10",
          title: "Electrical Equipment Industry",
          icon: electric,
        },
        {
          id: "industry11",
          title: "Garments/Apparel",
          icon: fashion,
        },
        {
          id: "industry12",
          title: "Leather Industry",
          icon: leather,
        },
        {
          id: "industry13",
          title: "Machinery & Equipment Industry",
          icon: equipment,
        },
        {
          id: "industry14",
          title: "Mining & Quarrying Industry",
          icon: gold,
        },
        {
          id: "industry15",
          title: "Pharmaceuticals Industry",
          icon: pharmaceuticals,
        },
        {
          id: "industry16",
          title: "Plastic Industry",
          icon: plastic,
        },
        {
          id: "industry17",
          title: "Printing & Packaging Industry",
          icon: printing,
        },
        {
          id: "industry18",
          title: "Rubber Industry",
          icon: rubber,
        },
        {
          id: "industry19",
          title: "Steel Industry",
          icon: steel,
        },
        {
          id: "industry20",
          title: "Wood Industry",
          icon: wood,
        },
        {
          id: "industry21",
          title: "Aluminium Manufacturing",
          icon: aluminium,
        },
      ],
    },

    benefits: {
      title: "Benefits of AI Implementation",

      benefitsData: [
             {
          section: "01",
          title: "Faster Decision-Making",
        },
        {
          section: "02",
          title: "Reduced Manual Work",
        },
        {
          section: "03",
          title: "Improved Accuracy",
        },
        {
          section: "04",
          title: "Better Resource Utilization",
        },
        {
          section: "05",
          title: "Predictable Operations",
        },
      ],
    },

    odooChoose: {
      title: "Why Choose Odoo?",
      description:
        "Unify your business with Odoo - a scalable, customizable, and mobile-ready platform with seamless integrations for faster decisions and smoother",
      features: [
        {
          id: 1,
          title: "Business-Driven Implementation",
          icon: businessIcon,
          image: business,
        },
        {
          id: 2,
          title: "Tailored AI Solutions",
          icon: solutionIcon,
          image: solution,
        },
        {
          id: 3,
          title: "Seamless Integration",
          icon: integrationIcon,
          image: integration,
        },
        {
          id: 4,
          title: "Practical Deployment",
          icon: practicalIcon,
          image: practical,
        },
        {
          id: 5,
          title: "End-to-End Support",
          icon: supportIcon,
          image: support,
        },
        {
          id: 6,
          title: "Outcome-Focused Approach",
          icon: approchIcon,
          image: approch,
        },
      ],
    },

    cta: {
      title: "Get Started With AI Implementation",
      description:
        "Fill out the form to begin a conversation about where AI can create practical value in your business. Our Team will review your requirements and help identify the right starting point for implementation.",
    },
    // features: [
    //   {
    //     icon: dataAnalyticsIcon,
    //     title: "AI-Powered Data Analytics",
    //     description:
    //       "Harness the power of AI to gain deep insights from your data, enabling smarter decisions and improved business outcomes.",
    //   },
    //   {
    //     icon: AutomationIcon,
    //     title: "Intelligent Automation",
    //     description:
    //       "Automate repetitive tasks with AI-driven solutions that enhance productivity, reduce errors, and free up valuable resources.",
    //   },
    //   {
    //     icon: maintenanceIcon,
    //     title: "Predictive Maintenance",
    //     description:
    //       "Utilize AI to predict and prevent equipment failures, reducing downtime and maintenance costs while improving operational efficiency.",
    //   },
    // ],

    // about: {
    //   subtitle: "AI-Powered Technology Solutions",
    //   heading: "Innovative Technology Solutions with AI Expertise",
    //   description:
    //     "GSUS Star Software is a leading provider of technology solutions, specializing in Artificial Intelligence, mobile app development, web app solutions, and ERP implementation. Our team of experts is dedicated to helping businesses harness the power of AI to drive innovation, improve efficiency, and achieve long-term success.",
    //   image: AiAboutImage,
    //   highlights: [
    //     "Generative AI",
    //     "Enterprise AI",
    //     "Data modernization",
    //     "Large Language Models",
    //   ],
    // },

    // services: {
    //   title: "Transform Your Business with AI-Driven Innovation",
    //   description:
    //     "Empower your business with cutting-edge AI solutions that drive efficiency, automation, and intelligent decision-making. From data analytics to natural language processing, our technologies unlock new opportunities for growth and smarter operations.",
    //   items: [
    //     {
    //       image: dataAnalyticsImage,
    //       name: "AI-Powered Data Analytics",
    //       description:
    //         "Transform your data into actionable insights with our AI-powered analytics solutions. We help you make informed decisions that drive business growth.",
    //       features: [
    //         "Advanced data mining techniques",
    //         "Customized reporting dashboards",
    //         "Real-time data processing",
    //         "Predictive analytics for future trends",
    //       ],
    //     },
    //     {
    //       image: automationImage,
    //       name: "Intelligent Automation",
    //       description:
    //         "Boost productivity and reduce operational costs with our AI-driven automation solutions. We streamline your workflows for maximum efficiency.            ",
    //       features: [
    //         "Process automation for routine tasks",
    //         "Custom workflows and automation",
    //         "AI-powered decision-making tools",
    //         "Integration with existing systems",
    //       ],
    //     },
    //     {
    //       image: NLPImage,
    //       name: "Natural Language Processing",
    //       description:
    //         "Enhance customer experiences with our NLP solutions. We enable seamless communication between humans and machines, improving user interaction and support.",
    //       features: [
    //         "Chatbot development",
    //         "Sentiment analysis",
    //         "Language translation",
    //         "Speech recognition and processing",
    //       ],
    //     },
    //   ],
    // },

    // cta: {
    //   title: "Unlock the Power of AI for Your Business",
    //   description:
    //     "Ready to enhance your business with cutting-edge AI solutions? Contact GSUS Star Software today and let our AI experts help you drive innovation, efficiency, and growth.",
    //   button: "Let's Talk",
    // },

    // faq: {
    //   items: [
    //     {
    //       question:
    //         "What are Artificial Intelligence services, and how can they benefit my business?",
    //       answer:
    //         "AI services use machine learning, data analysis, and automation to streamline processes, enhance decision-making, and improve overall efficiency, helping your business stay competitive.",
    //     },
    //     {
    //       question: "What types of AI solutions do you offer?",
    //       answer:
    //         "We offer AI-powered data analytics, intelligent automation, natural language processing (NLP), and predictive maintenance solutions tailored to your business needs.",
    //     },
    //     {
    //       question: "How can AI improve my business operations?",
    //       answer:
    //         "AI can automate repetitive tasks, provide real-time insights, and optimize decision-making, improving efficiency, reducing costs, and increasing productivity.",
    //     },
    //     {
    //       question: "Can AI be integrated with my existing systems?",
    //       answer:
    //         "Yes, our AI solutions can be integrated seamlessly with your current systems, ensuring smooth operations without disruptions.",
    //     },
    //     {
    //       question: "How long does it take to implement AI solutions?",
    //       answer:
    //         "The timeline varies depending on the complexity of your project, but most AI implementations can take anywhere from a few weeks to a few months.",
    //     },
    //     {
    //       question: "Is AI suitable for small and mid-sized businesses?",
    //       answer:
    //         "Absolutely. AI solutions can be customized for businesses of all sizes, helping to optimize operations and drive growth, regardless of scale.",
    //     },
    //     {
    //       question:
    //         "What kind of support do you offer after AI implementation?",
    //       answer:
    //         "We provide ongoing support, including updates, optimization, and troubleshooting, ensuring your AI solution continues to perform effectively.",
    //     },
    //     {
    //       question: "How does AI help with data security?",
    //       answer:
    //         "AI-powered systems enhance data security by identifying patterns, detecting anomalies, and responding to potential threats in real-time.",
    //     },
    //   ],
    // },
  },
};
export default aiServices;
